import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';

import { throwIfAlreadyLoaded } from '../guards/module-import.guard';
import { AlertComponent } from './alert.component';
import { AlertService } from './alert.service';
import { TranslateModule } from 'ng2-translate/ng2-translate';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    AlertComponent,
    TranslateModule
  ],
  declarations: [
    AlertComponent
  ],
  providers: [
    AlertService
  ]
})
export class AlertModule {
  constructor( @Optional() @SkipSelf() parentModule: AlertModule) {
    throwIfAlreadyLoaded(parentModule, 'ModalModule')
  }
}



// WEBPACK FOOTER //
// ./src/app/core/alert/alert.module.ts